"use strict";

import axios from "axios";
import store from '@/store'
import { UA_API_HOST, UMOOC_COOKIE_DOMAIN } from '@/config'
// import { lang } from '@/i18n'
import { exitApp, loggedOnOtherDevices } from '../cordova/index.js'
import { device } from '@/utils/device'
import { showMessage } from '@/utils/message';
import cookies from '@/utils/cookie'
let config = {
  baseURL: UA_API_HOST,
  timeout: 60 * 1000, // Timeout
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  (config) => {
    // Do something before request is sent
    config.headers['Authorization'] = store.getters['user/token'] || '24008AF9BB737FBC9DE19A559FC3A15F'
  //  config.headers['Authorization']='92302A289D0A63432A4398E82CA02824'
   //config.headers['Authorization']='036EA778DA5E247053A749E90A3F34CE'
    // config.headers['Accept-Language'] = lang
    return config;
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  (response) => {
    // Do something with response data
   // console.log(response);
  // return response.data;
    // Do something with response data
    const dataAxios = response.data
    // 这个状态码是和后端约定的
    const { code } = dataAxios
    // return response.data;
    if (code === undefined) {
      // 如果没有 code 代表这不是标准的后端开发的接口
      return dataAxios
    } else {
      // 有 code 代表这是一个后端接口 可以进行进一步的判断
      switch (code) {
        case 1:
          // [ 示例 ] code === 1 代表没有错误
          return dataAxios
        case 2:
          // [ 示例 ] 其它和后台约定的 code
          return Promise.reject(dataAxios)
          break
        default:
          // 不是正确的 code
          if (!device.isMobile) {
            // showMessage(dataAxios.message, 'warning')
          }
          return Promise.reject(dataAxios)
          break
      }
    }
  },
  (error) => {
    // Do something with response error
    if (error && error.response) {
      switch (error.response.status) {
        case 401:
          if (device.isRunningStandalone) {
            try {
              if (error.response.data.code == 2301) {
                loggedOnOtherDevices(() => {

                }, () => {
                  showMessage('已在其他终端登录!')
                  setTimeout(function () {
                    exitApp()
                  }, 1000)
                })
              }
            } catch (error) {
              console.log(error)
            }
          } else {
            if (
              error.response.data.code == 2001 ||
              error.response.data.code == 2101 ||
              error.response.data.code == 2201
            ) {
              cookies.set('loginRedirectUrl', location.href)
              window.location = `https://www${UMOOC_COOKIE_DOMAIN}/ulearning/tip/timeout.html`
              // showMessage('token过期', 'error')
              // window.location = "/ulearning/tip/timeout.html"; //域名待定
            }
          }
          break
        case 400:
          showMessage(error.response.data.message, 'error')
          break
        case 403:
          showMessage(error.response.data.message, 'error')
          break
        default:
          return Promise.reject(error)
          break 
      }
    }
    return Promise.reject(error);
  }
);

export default _axios;
